export const styles = {
  statBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '20px 4px',
    fontFamily: 'Proxima Nova',
  },
  value: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: 'black',
  },
  valueSmall: {
    fontSize: '14px',
    color: 'black',
    fontWeight: '400',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    color: 'rgba(127, 143, 164, 1)',
    fontSize: '12px',
    fontWeight: '600',
  },
}
